import { render } from "./ProcurementDetails.vue?vue&type=template&id=02293b58&scoped=true"
import script from "./ProcurementDetails.vue?vue&type=script&lang=js"
export * from "./ProcurementDetails.vue?vue&type=script&lang=js"

import "./ProcurementDetails.vue?vue&type=style&index=0&id=02293b58&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02293b58"]])

export default __exports__